module.exports = __webpack_public_path__ + "img/solution_building8.39b51bc2.png";